<script>
import { apiService } from '@/helpers/api.service';
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';


export default {
    name: 'DishCard',
    props: {
        dish: {
            type: Object,
        },
        actions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            glutenFree: false,
            vegan: false,
            veggie: false,
            healthy: false,
            addons: '',
            personalize: ''
        };
    },
    mounted() {
        this.wichType()
        this.personalize = this.handleOptions(this.dish?.personalize?.[0]?.options.filter(option => option.isVisible))
        this.addons = this.handleOptions(this.dish?.addon?.[0]?.options)
        this.canEditDish()
        this.canDeleteDish()
    },
    methods: {
        formatPrice(price) {
            if (!price) return '0';
            return Number(price) % 1 === 0
            ? Number(price).toFixed(0)
            : Number(price).toFixed(2);
        },
        canEditDish() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT, this.$store.state.permissions)
        },
        canDeleteDish() {
            return checkPermission(permissionsMap.DELETE_OWN_STORE_PRODUCT, this.$store.state.permissions)
        },
        wichType() {
            const type = this.dish.type
            if (type.indexOf('Gluten free') != -1) this.glutenFree = true
            if (type.indexOf('Vegan') != -1) this.vegan = true
            if (type.indexOf('Healthy') != -1) this.healthy = true
            if (type.indexOf('Vegetarian') != -1) this.veggie = true
        },
        toggleActiveDish() {
            if (this.dish.isActive) {
                event.preventDefault()
                this.$emit('is-active-dish')
            } else {
                this.dish.isActive = true
                apiService.patchIsActive(this.dish._id, { isActive: true })
            }
        },
        handleOptions(options) {
            if(options){
                options.sort((a, b) => (a.name > b.name) ? 1 : -1);
                const namesString = options.map(obj => {
                    const firstLetter = obj.name.charAt(0).toUpperCase();
                    const restOfName = obj.name.slice(1).toLowerCase();
                    return firstLetter + restOfName;
                }).join(', ');
                return namesString
            }
            return ''
        },
    },
}
</script>

<template>
    <div class="my-dish-card" :class="actions ? 'my-dish-card-actions' : 'my-dish-card-no-actions'">
        <div class="my-dish-card-modifiers" v-show='actions'>
            <img :style="{ 'display': canEditDish() ? 'block' : 'none' }" src="@/assets/images/edit.svg" alt="edit" @click="$emit('edit-dish')">
            <img :style="{ 'display': canDeleteDish() ? 'block' : 'none' }" src="@/assets/images/delete.svg" alt="delete" @click="$emit('delete-dish')">
        </div>
        <div class="my-dish-card-body">
            <div style="position: relative; max-height: 125px">
                <div v-if="(dish?.discount?.label && dish?.discount.amount !== 0)" class="my-dish-card-discount-bubble">
                    {{ dish?.discount.label }} off
                </div>
                <div class="my-dish-card-img">
                    <img :src="dish?.urlImage || require(`@/assets/images/welly-go-logo.svg`)" alt="dish"
                        class="my-dish-card-picture" :class="dish?.urlImage ? 'my-dish-card-picture-fit' : ''">
                </div>
                <div v-if="dish?.isCeliac" class="without-tacc-bubble">
                    <div>
                        <img src="@/assets/images/special/glutenfree-icon.svg" alt height="15" />
                        <p>Apto celíacos</p>
                    </div>
                </div>
            </div>
            <div>
                <h2>{{ dish?.name }}</h2>
                <p>{{ dish?.description }}</p>
                <p v-if="dish?.personalize?.[0]?.options.length > 0" class="my-dish-card-custom"><b>Gustos:</b> {{ personalize }} </p>
                <p v-if="dish.addon?.[0]?.options.length > 0" class="my-dish-card-custom"><b>Extras:</b> {{ addons }}</p>
                <p v-if="dish.observations"><span>Aclaraciones:</span>
                    {{ dish?.observations }} </p>
                <div class="my-dish-card-options">
                    <img class="vegan-icon" src="@/assets/images/special/vegan-icon.svg" alt="vegan" v-show="vegan" />
                    <img src="@/assets/images/special/veggie-icon.svg" alt="veggie" v-show="veggie" />
                    <img src="@/assets/images/sin-tacc-white-icon.svg" alt="gluten free" v-show="glutenFree"/>
                    <img src="@/assets/images/keto.svg" alt="saludable" v-show="healthy"/>
                </div>
                <h4 :class="dish?.discount?.amount ? 'my-dish-card-discount' : ''">${{ formatPrice(dish?.unitPrice) }} <span
                        v-if="dish?.discount?.amount">${{ formatPrice(dish?.price) }}</span></h4>
            </div>
        </div>
        <div class="col-lg-1 my-dish-card-activity" style="text-align:right" v-show='actions'>
            <b-form class="form-check form-switch form-switch-lg">
                <input :style="{ 'display': canEditDish() ? 'block' : 'none' }" class="form-check-input" id="input-1" type="checkbox" v-model="dish.isActive"
                    @click="toggleActiveDish()" />
            </b-form>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/dishCard';
</style>